module.exports = __webpack_public_path__ + "media/common/images/badges/gray/mas_stavu-a94ef51d380299c4cbd0af2b7e49ecb5.svg";